import { alpha } from "@mui/material";
import theme from "../../theme/Theme";


export const asideWidth = "300px";

const styles = {
  logo: {
    width: 100,
  },
  adminLayoutContainer: {
    display: "flex",
    flexDirection: "row",
    height: "100vh",
    width: "100%",
  },
  adminAside: {
    width: { xs: 0, md: asideWidth },
    backgroundColor: theme.custom.white,
  },
  adminMainContent: {
    width: { xs: "100%", md: `calc(100% - ${asideWidth})` },
    minHeight: "100vh",
    overflow: "auto",
    pt: "84px",
    px: { xs: 2, md: 4 },
    backgroundColor: alpha(theme.custom.primaryLighter, 0.6),
  },
  sidebarItemLabel: {
    fontSize: "1.2rem",
    fontWeight: 500,
    color: theme.custom.white,
    marginTop: "0.5em",
    marginBottom: "0.3em",
    "&:hover": {
      cursor: "pointer",
    }
  },
  sidebarItem: {
    padding: "2px 0.5em",
    marginBottom: "0.5em",
    color: theme.custom.white,
    marginTop: "0.5em",
    "&:hover": {
      cursor: "pointer",
    },
  },
  sidebarItemSelected: {
    padding: { xs: "1.5px 0.3em", sm: "1.5px 0.3em", md: "2px 0.5em" },
    marginBottom: "0.3em",
    marginTop: "0.5em",
    backgroundColor: alpha(theme.palette.primary.light, 0.4),
    borderLeft: `4px solid ${theme.palette.primary.light}`,
    color: theme.custom.white,
    "&:hover": {
      cursor: "pointer",
    },
    borderRadius: "100px",
  },
  buttonContainer: {
    background: "linear-gradient(180deg, #8D46DA 0%, #4B2574 100%)",
    borderRadius: "20px",
    textTransform: "none",
    color: "#fff",
    fontSize: "clamp(0.8rem, 2.5vw, 1rem)",
    fontWeight: 700,
    px: 3,
    py: 0.4,
    display: "flex",
    alignItems: "center",
    lineHeight: 1.8,
  },

  tableBackground: {
    mt: 4,
    borderRadius: "6px",
    overflowY: "hidden",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
    outline: `0.8px solid ${theme.custom.tableBorder}`,
  },
  ticketTitleStyle: {
    color: "rgba(0, 0, 0, 1)",
    fontSize: "0.75rem",
    fontWeight: 600,
    textAlign: "center",
    textTransform: "uppercase",
  },
  ticketValueTitleStyle: {
    color: "#525252",
    fontSize: "0.8rem",
    fontWeight: 600,
    textAlign: "center",
    padding: "0.5em 0",
    textDecoration: "none",
    border: "none",
  },
  bouncingCircleIcon: {
    width: "3em",
    my: 15,
  },
  logoContainer: {
    backgroundColor: theme.custom.white,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: -1,
    marginBottom: 5,
  },
  sidebarItemIcon: {

    height: "0.5em",
    color: theme.custom.white,
    marginBottom: "0.5em",
  },
  iconButtonStyle: {
    color: theme.palette.primary.main,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      color: theme.palette.primary.dark,
    },
    marginLeft: "10px",
  },
};


export default styles;
